import { render, staticRenderFns } from "./ChooseReasonButton.vue?vue&type=template&id=5a4950a5&"
import script from "./ChooseReasonButton.vue?vue&type=script&lang=js&"
export * from "./ChooseReasonButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports